import useExperiment from 'hooks/common/use-experiment';

interface UseTest10445Return {
  isVariantA: boolean;
  loading: boolean;
  variant: number | undefined;
}

/** A/B test: in-cart badge on product cards — variant 0 control, variant 1 shows the "Im Warenkorb" badge. */
const useTest10445 = (): UseTest10445Return => {
  const { variant, loading } = useExperiment({
    baseEntryId: '5fAD1AZ6imtiy87uIpcDeO',
  });

  return {
    isVariantA: !loading && variant === 1,
    loading,
    variant,
  };
};

export default useTest10445;
